import { getPaymentInfo } from '@jotta/grpc-connect-openapi/subscriptionQuery'
import { createConnectQuery } from '@jotta/grpc-connect-client/createConnectQuery'
import { authTransport } from '@jotta/grpc-connect-client/transport'

export const usePaymentInfo = createConnectQuery(getPaymentInfo, {
  transport: authTransport,
})
